import { render, staticRenderFns } from "./myCommunityList.vue?vue&type=template&id=a00cc318&scoped=true&"
import script from "./myCommunityList.vue?vue&type=script&lang=js&"
export * from "./myCommunityList.vue?vue&type=script&lang=js&"
import style0 from "./myCommunityList.vue?vue&type=style&index=0&id=a00cc318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00cc318",
  null
  
)

export default component.exports